import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { useLocalizedPath } from 'i18n/LanguageContext';

const LocalizedLink = forwardRef(({ to, ...rest }, ref) => {
    const localize = useLocalizedPath();
    return <Link ref={ref} to={localize(to)} {...rest} />;
});

LocalizedLink.displayName = 'LocalizedLink';

export default LocalizedLink;
